import {Injectable} from "@angular/core";
import {ApiConfig} from "./config.api";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ProfileApi {
  constructor(private httpClient:HttpClient) {
  }

  getAuthentecatedMenu() {
    return this.httpClient.get(ApiConfig.baseURL + 'api/profile/menu?lang=en');
  }
}
